import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
//import SplitPane from 'react-split-pane';
import DatedListItem from '../_partials/dated-list-item';
import store from '../store';
import DevView from '../_partials/dev-view';
import ViewSelect from '../_partials/view-select';

export default class Education extends Component {
  constructor(props) {
    super(props);
    this.state = {
      education: [],
      human: true,
    };
    this.storeListener = this.storeListener.bind(this);
  }

  async UNSAFE_componentWillMount() {
    const state = store.getState();
    this.setState({ education: state.education });

    this.unsubscribeStore = store.subscribe(this.storeListener);
  }

  UNSAFE_componentWillUnmount() {
    this.unsubscribeStore();
  }

  storeListener() {
    const state = store.getState();
    this.setState({ education: state.education });

    //console.log(this.state.education);
  }

  handleChange(viewState) {
    this.setState({ human: !viewState });
  }

  getView() {
    if (this.state.human) {
      return this.getEducationInfo(this.state.education);
    } else {
      return <DevView data={this.state.education} />;
    }
  }

  getEducationInfo(education) {
    return education.map(educItem => {
      return (
        <DatedListItem
          yearStart={educItem.years[0]}
          yearFinish={educItem.years.length > 1 ? educItem.years[educItem.years.length - 1] : null}
          companyName={educItem.institution}
          position={educItem.specializations[0]}
        ></DatedListItem>
      );
    });
  }
  render() {
    return (
      <Row className="portfolio__block" id="education">
        <Col>
          <h3 className="portfolio__block__heading">education</h3>
          <div className="portfolio__block__education">
            <ViewSelect onChange={this.handleChange.bind(this, this.state.human)} />
            <hr></hr>
            {this.getView()}
          </div>
        </Col>
      </Row>
    );
  }
}
